export const getCustomerAddress = (order) => {
  const address = []
  let location = null
  const addressArray = order?.customer?.customer_address?.split(',')

  addressArray?.forEach((item, index) => {
    index === addressArray?.length - 1 ? (location = item) : address.push(item)
  })
  return { address: address.join(','), location }
}

export const thereIsAnotherOrderToDeliver = (
  ordersToday,
  nextOrderToDeliver
) => {
  return ordersToday?.some(
    (order) =>
      order?.status_delivery_van === 'pending' &&
      order?.id !== nextOrderToDeliver?.id &&
      order?.customer?.customer_address ===
        nextOrderToDeliver?.customer?.customer_address
  )
}
